<template lang="pug">
  section.TourList(title="")
    TourListComponent
</template>

<script>

import TourListComponent from '@/components/TourList'
import i18n from '@/i18n'

export default {
  name: 'tour-list',
  components: {
    TourListComponent
  },
  data () {
    return {
      tours: null
    }
  },
  metaInfo () {
    return { title: this.$t('meta.title.tour') }
  }
}
</script>
